import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const postImportFile = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/import`;
const fetchUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/import`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 36e5,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  import(companyId, subcompanyId, data) {
    const url = postImportFile(companyId, subcompanyId);
    return this.axios
      .post(url, data, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  fetch(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = fetchUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/imports.api.js